import React, { forwardRef, memo } from "react";
import styles from "./Specs.module.scss";
import SpecsDetail from "./SpecsDetail";
import Text from "../../../../shared-components/css-modules/lexus/atoms/Text";
import SidePanel from "../../../../shared-components/css-modules/lexus/organisms/SidePanel";
import type { CarConfigDispatchType } from "../../../redux/store";
import { useCarConfigSelector } from "../../../redux/store";
import {
    selectCarConfigSpecsSearchActiveResult,
    setActiveResult,
} from "../../../redux/slices/CarConfigSpecsSearchSlice";
import { trackSpecsCategoryClick, trackSpecsCategoryClose } from "../../../utils/tracking";
import type { SpecGroupType } from "../../../hooks/useSpecs";
import { CarConfigLabel } from "../../../utils/labelUtils";
import sidepanelStyles from "../../../../shared-components/css-modules/lexus/organisms/SidePanel.module.scss";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const SpecGroup = forwardRef<HTMLDivElement, { group: SpecGroupType; index: number }>((props, ref) => {
    const { group, index } = props;
    const activeResult = useCarConfigSelector(selectCarConfigSpecsSearchActiveResult);
    const dispatch = useDispatch<CarConfigDispatchType>();

    return (
        <div
            className={styles["slider-item"]}
            style={{
                "--or-transition-delay": `${index * 50}`,
            }}
            ref={ref}
        >
            <button
                type="button"
                style={{
                    backgroundImage: `url(${group.image})`,
                }}
                onClick={(event) => {
                    event.preventDefault();
                    trackSpecsCategoryClick(group.name);
                    dispatch(setActiveResult({ groupId: group.id }));
                }}
            >
                <span className={styles["slider-item-title"]}>{group.name}</span>
                <div className={styles["slider-item-description"]}>
                    <div>
                        <Text variant="apheleia-h4" spacing="spacing-2">
                            {group.name}
                        </Text>
                        <Text tag="p" variant="apheleia-body-small" spacing="spacing-2">
                            {group.description}
                        </Text>
                        <Text tag="p" variant="apheleia-body-small" className={styles["slider-item-link"]}>
                            <CarConfigLabel label="carConfigSpecsLearnMore" />
                        </Text>
                    </div>
                </div>
            </button>
            <SidePanel
                variant="split-panel"
                open={activeResult?.groupId === group.id}
                fromDirection="none"
                mobileFromDirection="block-end"
                onRequestClose={() => {
                    trackSpecsCategoryClose(group.name);
                    dispatch(setActiveResult(null));
                }}
                title={group.name}
            >
                <div className={sidepanelStyles["split-panel-text"]}>
                    <SpecsDetail group={group} />
                </div>
                <div className={sidepanelStyles["split-panel-image"]}>
                    <img src={group?.imageLarge} alt={group?.name || ""} loading="lazy" />
                </div>
            </SidePanel>
        </div>
    );
});

export default memo(SpecGroup);
